var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncassiPrevisti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 339.23 339.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_15",
    "data-name": "Tracciato 15",
    fill: "currentColor",
    d: "M250.54,80A169.62,169.62,0,1,0,370.3,129.65,169.61,169.61,0,0,0,250.54,80Zm0,310.11A140.84,140.84,0,1,1,350,348.85,140.85,140.85,0,0,1,250.54,390.1Z",
    transform: "translate(-80.77 -79.99)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16",
    "data-name": "Tracciato 16",
    fill: "currentColor",
    d: "M313,209.72c.21-.57.38-1.15.53-1.73a9.62,9.62,0,0,1,.42-1.44,16.52,16.52,0,0,0,0-6.57,5.54,5.54,0,0,0-.42-1.44,9.68,9.68,0,0,0-1.35-3.31,2.58,2.58,0,0,0-.72-1.29,17,17,0,0,0-2.1-2.54l-46.89-46.88a16.93,16.93,0,0,0-2.59-2.11c-.38-.29-.87-.43-1.25-.67a9.44,9.44,0,0,0-3.3-1.39,8.56,8.56,0,0,1-1.44-.43,16.89,16.89,0,0,0-6.57,0,5.1,5.1,0,0,0-1.44.43,9.49,9.49,0,0,0-3.31,1.39c-.43,0-.87.43-1.25.67a16.93,16.93,0,0,0-2.59,2.11L191.8,191.4a16.45,16.45,0,0,0-2.11,2.54,13.89,13.89,0,0,0-.72,1.29,9.66,9.66,0,0,0-1.34,3.31,9.62,9.62,0,0,1-.42,1.44,16.52,16.52,0,0,0,0,6.57,5.54,5.54,0,0,0,.42,1.44A9.66,9.66,0,0,0,189,211.3a2.62,2.62,0,0,0,.72,1.29,16.81,16.81,0,0,0,4.79,4.79,13.75,13.75,0,0,0,1.25.67,9.65,9.65,0,0,0,3.3,1.4,7.7,7.7,0,0,1,1.44.42h0a17.53,17.53,0,0,0,3.31.34h30.11v122.2a16.78,16.78,0,0,0,33.56,0V220.11h30.1a16.74,16.74,0,0,0,3.31-.33,5.56,5.56,0,0,0,1.44-.43,9.57,9.57,0,0,0,3.31-1.39c.42,0,.86-.43,1.24-.67a17,17,0,0,0,4.8-4.79c.28-.43.48-.87.71-1.3a9.91,9.91,0,0,0,.58-1.48Z",
    transform: "translate(-80.77 -79.99)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncassiPrevisti);
export default __webpack_public_path__ + "static/media/incassi-previsti.71eb5c45cd68ed1b970efe6cc7d46243.svg";
export { ForwardRef as ReactComponent };